<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>
 body{
   margin:0 !important;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue